import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

import WebApp from '@twa-dev/sdk'
import { logger } from './utils/logger'

WebApp.ready()
logger.info('WebApp ready')

WebApp.enableClosingConfirmation()
logger.info('Closing confirmation enabled')

// Добавляем обработчики только для логирования, не для функциональности
WebApp.onEvent('mainButtonClicked', () => {
  logger.info('MainButton clicked - event logged')
  // НЕ добавляем никакой функциональности здесь!
})

WebApp.onEvent('viewportChanged', () => {
  logger.info('Viewport changed', {
    height: WebApp.viewportHeight,
    stableHeight: WebApp.viewportStableHeight
  })
})

WebApp.onEvent('themeChanged', () => {
  logger.info('Theme changed')
})

WebApp.onEvent('popupClosed', () => {
  logger.info('Popup closed')
})

// Добавляем обработчики для отправки данных
WebApp.onEvent('invoiceClosed', () => {
  logger.info('Invoice closed')
})

WebApp.onEvent('settingsButtonClicked', () => {
  logger.info('Settings button clicked')
})

WebApp.onEvent('backButtonClicked', () => {
  logger.info('Back button clicked')
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
